import CoursesContent from "../../components/others/courses/CoursesContent";
import CoursesLayout from "../../components/layouts/courses/CoursesLayout";
import CoursesContentLayout from "../../components/layouts/courses/CoursesContentLayout";
import SystemScreenTopBar from "../../components/bars/SystemScreenTopBar";
import {kHomeTexts} from "../../constants/texts";
import {useState} from "react";
import {useResizeListener} from "../../listeners/SystemResizeListener";
import SystemAppDrawer from "../../components/others/SystemAppDrawer";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";

export default function CoursesScreen({ selectedGrade,
                                        setFlashGrade,
                                        fetchQuestionsCallback,
                                        fetchExerciserProblemCallback }) {
    // Used in MetaCoursesScreen for the user to select LevelAs through
    // Subthemes

    // PROPERTIES
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return (
        <div className="animate-appear overflow-auto bg-backgroundLight3 w-full h-[100svh] flex flex-col items-center justify-start">
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Cours et exercices')}</title>
                <meta name="description"
                      content="Explications et exercices pour maitriser chaque savoir-faire fondamental du collège." />
            </Helmet>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar currentTab={kHomeTexts.navCourses}
                                openDrawer={openDrawer} />
            <CoursesLayout>
                <CoursesContentLayout>
                    <CoursesContent setFlashGrade={setFlashGrade}
                                      selectedGrade={selectedGrade}
                                      fetchQuestionsCallback={fetchQuestionsCallback}
                                      fetchExerciserProblemCallback={fetchExerciserProblemCallback} />
                </CoursesContentLayout>
            </CoursesLayout>
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }
}
